import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageBackend from "i18next-localstorage-backend";

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.use(LocalStorageBackend)
	.use(Backend)
	.init({
		fallbackLng: "en",
		debug: true,
		supportedLngs: ["nb-NO", "nb", "en"],

		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},

		react: {
			useSuspense: true, // not needed as the language file is a json file
		},

		backend: {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
		},
	});

export default i18next;
